import { init as initApm } from '@elastic/apm-rum'
import { Environment, MySquid, onLangChange } from '@hub/shared'
import ContractLayout from '@layouts/contract/contract.layout'
import ErrorLayout from '@layouts/error/error.layout'
import { useEffect } from 'react'
import { Navigate } from 'react-router'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import { SubscriptionLike } from 'rxjs'
import i18n from './i18n.outside'

export default function Root(props: { configs: MySquid; environments: Environment; mountParcel: any; name: string; singleSpa: any }) {
  useEffect(() => {
    const onLangChangeObservable: SubscriptionLike = onLangChange.subscribe((lang: 'pt' | 'en' | 'es') => {
      i18n.changeLanguage(lang)
    })
    return () => {
      onLangChangeObservable?.unsubscribe()
    }
  }, [])

  useEffect(() => {
    initApm({
      environment: props.environments.env,
      serviceName: 'web-hub-outside',
      serverUrl: props.environments.apmUrl,
    })
  }, [props.environments])

  return (
    <Router>
      <Routes>
        <Route path="contract/*" element={<ContractLayout {...props} />} />
        <Route path="error/*" element={<ErrorLayout {...props} />} />
        <Route path="/" element={<Navigate to={{ pathname: '/error/not-found' }} />} />
      </Routes>
    </Router>
  )
}
